import { render, staticRenderFns } from "./aprobarRechazarCredito.vue?vue&type=template&id=d32c23c2&scoped=true"
import script from "./aprobarRechazarCredito.vue?vue&type=script&lang=js"
export * from "./aprobarRechazarCredito.vue?vue&type=script&lang=js"
import style0 from "./aprobarRechazarCredito.vue?vue&type=style&index=0&id=d32c23c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32c23c2",
  null
  
)

export default component.exports